import React from 'react';
import { CreateAdCampaignDto } from 'types/ad-campaign';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';

import CreateAdCampaignView from 'views/Dashboard/ad-campaigns/CreateAdCampaignView';
import { toast } from 'sonner';

type Props = {
  handleNext: () => void;
  setCreateAdCampaignData: React.Dispatch<React.SetStateAction<CreateAdCampaignDto | undefined>>;
};

export default ({
  handleNext, setCreateAdCampaignData,
}: Props) => {
  const { user, isAnyAgent } = useAuthDataContext();

  const onSimpleViewSubmit = (data: CreateAdCampaignDto) => {
    if (user && !isAnyAgent) {
      toast.warning('You can not proceed on a non-agent account.', { duration: 15000 });
      return;
    }

    setCreateAdCampaignData(data);

    handleNext();
  };

  return (
    <CreateAdCampaignView onSimpleViewSubmit={onSimpleViewSubmit} />
  );
};
